<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks'

    export default {
        components: {
            AppTabLinks
        },

        data() {
            return {
                isAuthorized: false,
                list: []
            }
        },
        mounted() {
            if(this.adminOnly()) {
                this.list = [
                    {
                        title: 'Настройки',
                        url: `/onboarding/${this.$route.params.id}/edit`,
                    },
                    {
                        title: 'Сторисы',
                        url: `/onboarding/${this.$route.params.id}/stories`,
                    },
                ]
            }
        },
        methods: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
        }
    }
</script>
